import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { useMemo } from "preact/hooks"
import { productImagePlaceholder } from "../helpers"

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)

    const productHandle = useMemo(() => product?.url.split("/").pop(), []);
    // console.log(productHandle, "handle");
    // console.log(product?.skus[0]?.id, "variant");

    return (
        <SerpElement
            as="dynamic-product-card"
            hit={product}
            class="ns-product relative group flex flex-col justify-between h-full"
            handle={productHandle}
            variant={product?.skus[0]?.id}
            template="product-card-carousel"
        ></SerpElement>
    )
}

// version commented on October 2nd to adapt code for ADA compliance



// import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
// import { useMemo } from "preact/hooks"
// import { productImagePlaceholder } from "../helpers"

// export default function Product({ product }) {
//     const { format } = useCurrencyFormatting()
//     const tags = [
//         product.onSale
//             ? {
//                   label: "Sale",
//                   class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
//               }
//             : undefined
//     ].filter(v => !!v)

//     const productHandle = useMemo(() => product?.url.split("/").pop(), []);
//     // console.log(productHandle, "handle");
//     // console.log(product?.skus[0]?.id, "variant");

//     return (
//         <SerpElement
//             as="dynamic-product-card"
//             hit={product}
//             ariaLabel={`Product ${product.name}`}
//             class="ns-product relative group flex flex-col justify-between h-full"
//             handle={productHandle}
//             variant={product?.skus[0]?.id}
//             template="product-card-carousel"
//         ></SerpElement>
//         // <SerpElement
//         //     as="div"
//         //     hit={product}
//         //     ariaLabel={`Product ${product.name}`}
//         //     class="ns-product relative group flex flex-col justify-between h-full"
//         // >
//         //     <dynamic-product-card handle={productHandle} variant={product?.skus[0]?.id} 
//         //     template="product-card-carousel"
//         //     ></dynamic-product-card>
//         // </SerpElement>
//     )
// }
